import React from 'react';
import PropTypes from 'prop-types';

import PricingStatusBadge from 'features/ManageServices/Components/ServicePricingSection/PricingStatusBadge/PricingStatusBadge';

import messages from '../ClassesList.messages';
import { getIntegratedBookableStatusDisplay } from '../ClassesList.helpers';

const BookableStatus = ({ venueClass }) => {
  const { classId } = venueClass;
  const { messageKey, iconType, tooltipMessageKey } = getIntegratedBookableStatusDisplay(venueClass);

  return (
    <PricingStatusBadge
      iconType={iconType}
      messageKey={messageKey}
      messages={messages}
      tooltipMessageKey={tooltipMessageKey}
      tooltipName={`bookable-status-tooltip-${classId}`}
    />
  );
};

BookableStatus.propTypes = {
  venueClass: PropTypes.shape({
    classId: PropTypes.number,
    disabled: PropTypes.bool,
    retailRateRequest: PropTypes.shape({
      status: PropTypes.string,
      statusReason: PropTypes.string,
    }),
    classPricingRule: PropTypes.shape({}),
  }),
};

export default BookableStatus;
